import { render, staticRenderFns } from "./AppStoreHome.vue?vue&type=template&id=610c475a&scoped=true&"
import script from "./AppStoreHome.vue?vue&type=script&lang=js&"
export * from "./AppStoreHome.vue?vue&type=script&lang=js&"
import style0 from "./AppStoreHome.vue?vue&type=style&index=0&id=610c475a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610c475a",
  null
  
)

export default component.exports